<template>
    <program-sponsors-list routeName="employee-internship-sponsor-details"></program-sponsors-list>
</template>

<script>
import ProgramSponsorsList from '@/views/Employee/ProgramComponents/ProgramDetails/ProgramSponsors/ProgramSponsorsList.vue'

export default {
    name: "InternshipSponsorList",
    components: {ProgramSponsorsList  },
    data: () => ({})
}
</script>